import { render } from "./Aquarius.vue?vue&type=template&id=649716e4&scoped=true"
import script from "./Aquarius.vue?vue&type=script&lang=js"
export * from "./Aquarius.vue?vue&type=script&lang=js"

import "./Aquarius.vue?vue&type=style&index=0&id=649716e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649716e4"]])

export default __exports__